import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from "chart.js";
ChartJS.register(BarElement, CategoryScale, LinearScale);

const Calendar = () => {
    const barChartData = {
        labels: ["Designing", "Developing", "Testing", "Deployment"],
        datasets: [
            {
                label: "Designing",
                data: [1,0,0,0],
                backgroundColor: "rgba(0,255,0,0.2)",
            },
            {
                label: "Developing",
                data: [0,2,0,0],
                backgroundColor: "rgba(0,0,255,0.2)",
            },
            {
                label: "Testing",
                data: [0,0,0.5,0],
                backgroundColor: "rgba(255,0,0,0.2)",
            },
            {
                label: "Deployment",
                data: [0,0,0,0.25],
                backgroundColor: "rgba(255,0,178,0.2)",
            }
        ]
    }
    const barChartSettings = {
        responsive: true,
        scales: {x:{stacked: true}}
    }
    return (
        <>
            <header>
                <h1 className="heading1">Calendar [Under Construction]</h1>
                <h2 className="heading2">Never miss a deadline again!</h2>
            </header>
            <main>
                <div className="graph" aria-label="dev timeline graph">
                    <h2>Dev Timeline</h2>
                    <Bar data={barChartData} options={barChartSettings}
                         aria-label="bar chart showing designing, developing, testing, and deployment phases for website production"
                    />
                </div>
            </main>
        </>
    )
};
export default Calendar;